import styled from "styled-components";

export const DateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Term = styled.div``;
